export default {
  signworkflowsVueOrder: state => state.signworkflowsVueOrder,
};
